<template>
  <div class="user-auth-state">
    <z-fix-top keep-position class="fixtop">
      <z-nav-bar class="navbar" left-arrow :title="navtitle" @click-left="closePage"> </z-nav-bar>
    </z-fix-top>
    <section class="cell" v-show="hasVerified">
      <img :src="successImg" />
      <div class="result-info">
        <div class="info">
            <span>{{name}}</span>
            <span>{{cardId}}</span>
        </div>
        <header>你已完成实人认证</header>
      </div>
    </section>
    <section class="notcell" v-show="!hasVerified">
      <img :src="failImg" />
      <div class="result-info">
        <header>你尚未实人认证</header>
        <div>
          <div class="desc">{{ msg }}</div>
        </div>
      </div>
      <div class="operation-area">
        <div v-if="!hasVerified">
          <z-button type="primary" @click="goVerify">去认证</z-button>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import native from '@zz-common/native-adapter'
import { lego } from '@zz-common/lego'
import { FixTop, NavBar, Button } from '@zz-common/zz-ui'
import { queryParams, getCookie } from '../../lib/utils'
import { getAlreadyCertificationInfo } from '@api/resourceApi'

const query = queryParams()

export default {
  name: 'masterBear',
  data() {
    return {
      from: query.from || this.$route.query.from,
      verified: query.verified || this.$route.query.verified,
      msg: '实人认证是由转转合作的第三方（腾讯云）使用全球领先的人脸识别技术实现对您身份的有效核定。',
      successImg: require('./images/auth_success.png'),
      name: '',
      cardId: '',
      failImg: require('./images/auth_fail.png'),
      navtitle: '实人认证'
    }
  },
  computed: {
    hasVerified() {
      return this.verified && this.verified != '0'
    }
  },
  methods: {
    goVerify() {
      lego.send({
        pagetype: 'auth_privateinfo_master_bear',
        actiontype: 'click_verify',
        backup: {
          sourcecode: this.from,
          version: getCookie('v'),
          app: 'zzqcidentity',
          verified: this.hasVerified
        }
      })
      native.skipToUrl({
        targetUrl: `https://m.zhuanzhuan.com/platform/zz-universal-pages/index.html#/realauth/verifyface?sourcecode=${this.from}`,
        needClose: '1'
      })
    },
    closePage() {
      native.close()
    },
    initData() {
      if (this.hasVerified) {
        getAlreadyCertificationInfo().then((res) => {
          const { name, cardId } = res;
          this.name = name;
          this.cardId = cardId;
        })
      }
    }
  },
  created() {
    native.wrap('setHeaderVisible')({
      visible: '0'
    })
    this.initData()
  },
  components: {
    'z-nav-bar': NavBar,
    'z-fix-top': FixTop,
    'z-button': Button
  }
}
</script>

<style lang="less" scoped>
@import 'index.less';
</style>
